module.exports = __webpack_public_path__ + "img/dgd.38e337fb.svg";